import { Inset, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { SubmitOnboardingCallback } from '../../pages/onboarding-workflow/OnboardingWorkflow'
import { CtaButton } from './CtaButton'
import { Section } from './Section'
import { CtaButtonProps, SectionProps, TemplateResponseData, ExtraData } from './types'
import { WorkflowEventTrackingProps } from '../../../events'

type FooterSectionProps = {
  section: SectionProps
  onDataUpdate: (path: string, value) => void
  templateResponseData: TemplateResponseData
  onSubmitStep: SubmitOnboardingCallback
  buttons: CtaButtonProps[]
  extraData?: ExtraData
  trackWorkflowEvent: (trackingData: WorkflowEventTrackingProps) => void
}

export const FooterSection: React.FC<FooterSectionProps> = ({
  section,
  onDataUpdate,
  templateResponseData,
  onSubmitStep,
  buttons,
  trackWorkflowEvent,
  extraData,
}) => {
  return (
    <Inset size={Inset.Sizes.Large}>
      <StackChildren size={StackChildren.Sizes.XxSmall}>
        {section && section.components.length > 0 && (
          <Section
            section={section}
            onDataUpdate={onDataUpdate}
            templateResponseData={templateResponseData}
            onSubmitStep={onSubmitStep}
            extraData={extraData}
            trackWorkflowEvent={trackWorkflowEvent}
          />
        )}
        {buttons.map((buttonProps, index) => (
          <CtaButton
            key={index}
            props={buttonProps}
            templateResponseData={templateResponseData}
            onSubmitStep={onSubmitStep}
            trackWorkflowEvent={trackWorkflowEvent}
          />
        ))}
      </StackChildren>
    </Inset>
  )
}
